import request from '@/helpers/request'
import Vue from 'vue'
import store from '@/store'
import CityFactory from '@/factory/city'
import UnitFactory from '@/factory/unit'
import ServerValidationError from '@/helpers/ServerValidationError'
import full_name from '@/helpers/full_name'
import router from '@/router'
import snack from '@/helpers/snack'
import axios from 'axios'
import moment from 'moment'

const createBooking = payload => {
  return axios.post(`${Vue.config.server}/${Vue.config.modules.crm.api.bookings.all}`, payload)
}
const unitsAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.units.all}`, { params: payload })
}
const statusesAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.bookings.statuses}`, { params: payload })
}

export default {
  GET_UNITS_FOR_CURRENT_CITY({ commit, state }, payload) {
    const unitsPayload = {
      with: 'neighbours',
      search: `location_type:${Vue.config.modules.crm.staticData.unitLocationType};type:${Vue.config.modules.crm.staticData.unitTypeUnit};location_id:${payload.cityID}`,
      searchFields: 'location_type:=;type:=;location_id:=',
      searchJoin: 'and',
    }
    Object.assign(unitsPayload, payload)
    return unitsAll(unitsPayload).then(response => {
      store.commit('setUnits', response.data.data.items)
    })
  },

  GET_BOOKING_STATUSES({ commit, state }, payload) {
    return statusesAll().then(response => {
      store.commit('setBookingStatuses', response.data.data.items)
    })
  },

  GET_BOOKING_WITH_BOOKINGS({ commit, state }, bookingID) {
    commit('setLoad', true)

    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.one.replace('$1', bookingID)}`,
      {
        params: {
          with: 'status;author;bookingSource;unit;appliedDiscount;address.metro;visitBooking;visitBooking.images',
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const booking = response.data.data

          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.one.replace('$1', bookingID)}`,
            {
              params: {
                with: 'status;author;bookingSource;unit;appliedDiscount;address.metro;visitBooking;visitBooking.images',
              },
              headers: {
                'X-Timezone': booking.unit?.timezone || 'Europe/Moscow',
              },
            },
            true,
          ).then(response => {
            const booking = response.data.data
            commit('setBooking', booking)
            commit('setBookings', state.bookings.concat(booking))
            commit('setTitle', `Заявка #${booking.id}`)

            // Get customers
            return request(
              'GET',
              `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.all}`,
              {
                params: {
                  offset: 0,
                  limit: 30,
                  sortedBy: 'desc',
                  orderBy: 'id',
                },
              },
              true,
            )
          })
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data

          const bookings = Array.from(state.bookings)

          for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].id == bookings[0].id) {
              continue
            }
            bookings.push(data.items[i])
          }
          commit('setBookings', bookings)
          commit('setBookingsFilters', data.filters)
          commit('setLoad', false)

          return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.statuses}`, {}, true)
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setBookingStatuses', data.items)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
  },

  GET_BOOKING_DATA_LIST: ({ commit, state }) => {
    commit('setLoad', true)

    // Get customers
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.all}`,
      {
        params: {
          offset: 0,
          limit: 30,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setBookings', state.bookings.concat(data.items))
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },

  GET_BOOKING_FILTERED: ({ commit, state }, params) => {
    commit('setLoad', true)
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.all}`,
      {
        params: params.params,
      },
      true,
    )
      .then(response => {
        const data = response.data.data
        commit('setBookings', data.items)
        commit('setLoad', false)
      })
      .finally(() => {
        commit('setLoad', false)
      })
  },

  GET_BOOKINGS: ({ commit, state }, { params = {}, showPreloader, callback }) => {
    return new Promise((resolve, reject) => {
      if (showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.all}`,
        {
          params: params,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          if (!params.offset) {
            commit('setBookings', [])
          }
          commit('setBookings', data.items)
          commit('setLoad', false)
          callback ? callback(state.bookings) : null
          resolve(data)
        })
        .catch((error, response) => {
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },

  UPDATE_BOOKING: async ({ commit, state, dispatch }, { load = false, callback, timezone }) => {
    commit('setLoad', load)

    const headers = {}
    const visitRequestBody = {
      photos_to_remove: state.booking.imagesForRemove,
      colors: state.booking.newColors,
    }
    const requestBody = {
      status_id: state.booking.status_id,
      cancel_source_id:
        state.booking.status.type === 'cancel' ? store.getters.bookingSources.find(x => x.alias === 'crm').id : null,
      comment: state.booking.comment ? state.booking.comment : '',
    }

    if (timezone) headers['X-Timezone'] = timezone

    if (state.booking.newAttachedImages?.length) {
      const payload = {
        booking_id: state.booking.id,
        type: 'wish',
        photos: state.booking.newAttachedImages,
      }

      await axios.post(
        `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.attachPhotos}`,
        Vue.prototype.$getFormData(payload),
      )

      commit('setBookingField', {
        key: 'newAttachedImages',
        value: [],
      })
    }

    await axios.post(
      `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.updateVisitInfo.replace('$1', state.booking.id)}`,
      visitRequestBody,
    )

    await axios
      .put(
        `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.one.replace('$1', state.booking.id)}`,
        requestBody,
        {
          headers,
        },
      )
      .then(({ data: { result, data } }) => {
        if (result === 'success') {
          if (load) {
            dispatch('GET_BOOKING_HISTORY', state.booking.id)
            commit('setTitle', `Заявка #${state.booking.id}`)
            commit('setLoad', false)

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.savedMessage,
            })
          }

          if (callback) {
            callback(_.cloneDeep(state.booking))
          }

          if (data.visit_booking) {
            commit('setBookingField', {
              key: 'visit_booking',
              value: data.visit_booking,
            })
          }
        } else {
          // TODO: Show error dialog
        }
      })
  },

  GET_BOOKING({ commit, state }, payload) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.one.replace('$1', payload.bookingID)}`,
      {
        params: {
          with:
            'status;author;bookingSource;userTransactions;appliedDiscount;appliedDiscount.fromEmployer;visitBooking;visitBooking.images;clubCards;user;user.clubCard;voucher',
        },
      },
      true,
    ).then(response => {
      const booking = response.data.data
      commit('setBooking', booking)

      if (payload.title) {
        commit('setTitle', `Заявка #${state.booking.id}`)
      }

      commit('setLoad', false)
    })
  },

  async UPDATE_BOOKING_BY_ID({ commit, state }, { bookingId, params }) {
    try {
      const response = await request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.one.replace('$1', bookingId)}`,
        params,
        true,
      )
      if (response.data.result === 'success') {
        return response.data.data
      } else {
        throw response
      }
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.errorSavingMessage)
    }
  },

  async FETCH_BOOKING_STATUSES({ commit, state }, payload) {
    try {
      const response = await statusesAll()
      if (response.data.result === 'success') {
        return response.data.data.items
      } else {
        throw response
      }
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.errors.bookingStatusesLoadError)
    }
  },

  async FETCH_BOOKING_BY_ID({ commit, state }, payload) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.one.replace('$1', payload)}`,
        {
          params: {
            // with: 'status;author;bookingSource',
            with: 'unit',
          },
        },
        true,
      )
      if (response.data.result === 'success') {
        return response.data.data
      } else {
        throw response
      }
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.errors.bookingLoadError)
    }
  },

  DELETE_BOOKING: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.one.replace('$1', state.booking.id)}`,
      {},
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          commit('deleteBooking', state.booking.id)
          const bookingsLength = state.bookings.length

          if (bookingsLength != 0) {
            commit('setBooking', state.bookings[0])
            commit('setBookingField', { key: 'id', value: state.bookings[0].id })
            commit('setTitle', `Заявка #${state.bookings[0].id}`)

            commit('setBookingErrors', null)
            commit('setLoad', false)

            router.push({
              path: Vue.config.modules.crm.route.bookings.one.replace('$1', state.bookings[0].id),
            })

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.deleteMessage,
            })
          } else {
            router.push({ path: Vue.config.modules.crm.route.bookings.all })
          }
        } else {
          commit('setServiceErrors', null)
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: Vue.config.localization.ru.notFoundMessage,
          })
          // TODO: Show error dialog
        }
      },
      e => {
        ServerValidationError.notify(e, 'customerValidation')
        commit('setLoad', false)
      },
    )
  },

  GET_NEW_BOOKING_DATA: ({ commit, state }, { isSaved = false, callback }) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.cities.all}`,
      {
        params: {
          orderBy: 'name',
          sortedBy: 'asc',
          whereHas: 'units',
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const cities = response.data.data.items
          commit('setCities', cities)
          commit('setCity', new CityFactory().create())

          const unit = new UnitFactory().create()
          commit('setUnit', unit)

          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.all}`,
            {
              params: {
                with: 'services',
              },
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const serviceCategories = response.data.data.items

          for (let i = 0; i < serviceCategories.length; i++) {
            const serviceCategory = serviceCategories[i]
            serviceCategory.active = false

            for (let j = 0; j < serviceCategory.services.length; j++) {
              const service = serviceCategory.services[j]
              service.service_category = serviceCategory
              service.active = false
            }
          }

          commit('setServiceCategories', serviceCategories)

          if (isSaved) {
            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.savedMessage,
            })
          }

          callback ? callback() : null
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
  },

  GET_USER_SEARCH: ({ commit, state }, payload) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.users.search}`,
      {
        params: {
          name: payload,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const users = _.forEach(_.cloneDeep(response.data.data.items.data), user => {
          let firstName = user.first_name || ''
          let lastName = user.last_name || ''
          let phone = user.phone ? user.phone.substr(-4) || '' : ''
          user.name = `${firstName} ${lastName} ${phone}`
        })

        commit('setUsers', users)
      }
    })
  },

  GET_EMPLOYER_SEARCH: ({ commit, state }, payload) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
      {
        params: {
          search: `id:${payload};workPosition.type_position:master,top_master;blocked_at:null`,
          searchFields: 'id:plastic:employer;workPosition.type_position:in;blocked_at:1',
          searchJoin: 'and',
          limit: 2000,
          offset: 0,
        },
      },
      true,
    ).then(response => {
      // @TODO как сделаете алиасы - перекиньте на алиас.
      if (response.data.result === 'success') {
        const employers = _.filter(_.cloneDeep(response.data.data.items), employer => {
          if (Vue.config.modules.crm.availableWorkPositions.includes(employer.work_position_id)) return employer
        })
        commit('setEmployers', employers)
      }
    })
  },

  GET_MASTERS_BY_UNIT: ({ commit, state }, payload) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const employers = response.data.data.items

        commit('setEmployers', employers)
      } else {
        // TODO: Show error dialog
      }
    })
  },

  GET_JOINS_FOR_BOOKING: ({ commit, state, rootGetters }, payload) => {
    commit('setLoad', true)
    commit('setBookingLoad', true)
    const newBooking = store.getters.newBookings[payload.bookingIndex]

    const activeServiceIDs = []
    _.forEach(newBooking.services, service => {
      activeServiceIDs.push(service.id)
    })

    const params = {
      begin_at: payload.beginAt,
      end_at: payload.endAt,
      service_ids: activeServiceIDs,
    }

    const currentParallel = newBooking.parallel ? 1 : 0

    if (newBooking.master && newBooking.master.id !== undefined) {
      // Search by master (employer)
      params.type = 'employer'
      params.parallel = currentParallel
      params.employer_id = newBooking.master.id
    } else if (newBooking.unit && newBooking.unit.id !== undefined) {
      let unitIds = []

      if (payload.withNeighbours) {
        unitIds = newBooking.unit.neighbours.map(function (item) {
          return item.id
        })
        unitIds.push(newBooking.unit.id)
      } else {
        unitIds = [newBooking.unit.id]
      }

      // Search by unit
      params.type = 'unit'
      params.parallel = currentParallel
      params.unit_ids = unitIds
      params.price_company_id = newBooking.unit.company_id
    } else {
      // Search by location
      params.type = 'location'
      params.parallel = currentParallel
      params.location_type = Vue.config.modules.crm.staticData.unitLocationType
      params.location_id = newBooking.city.id
    }

    /* @ToDo: typofix */
    if (!params.hasOwnProperty('price_company_id')) {
      params.price_company_id = 1
    }

    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.windows.searchNew}`,
      {
        params: params,
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
        },
      },
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          const windows = _.map(response.data.data.windows, join => {
            join.type = 'windows'
            return join
          })
          const schedules = _.map(response.data.data.schedules, join => {
            join.type = 'schedules'
            return join
          })
          const joins = _.sortBy([...windows, ...schedules], [item => item[0].begin_at])
          let joinID = 0
          const result = []

          _.forEach(joins, join => {
            const windows = []
            const currentJoin = join

            _.forEach(join.ranges, range => {
              const beginAt = range[0]
              const endAt = range[1]
              windows.push({
                windowType: 'schedules',
                begin_at: beginAt,
                active: false,
                duration: endAt - beginAt,
                employer_id: currentJoin.employer_id,
                end_at: endAt,
                first_name: currentJoin.first_name,
                id: currentJoin.id,
                joinID: joinID,
                last_name: currentJoin.last_name,
                rating: currentJoin.rating,
                services: currentJoin.services,
                unit_name: currentJoin.unit_name,
              })
            })

            if (join['type'] === 'schedules') {
              result.push({
                id: joinID,
                type: join.type,
                active: false,
                expanded: false,
                windows: join,
              })
            } else {
              result.push({
                id: joinID,
                type: join.type,
                active: false,
                windows: join,
              })
            }
            joinID++
          })

          commit('setNewBookingJoins', {
            bookingIndex: payload.bookingIndex,
            joins: result,
          })
          commit('setBookingLoad', false)
          commit('setLoad', false)
        }
      },
      response => {
        commit('setLoad', false)
      },
    )
  },

  CREATE_BOOKING: ({ commit, state, rootGetters }, payload) => {
    const newBooking = store.getters.newBookings[payload.bookingIndex]
    const bookingSources = store.getters.bookingSources
    let bookingPayload = {}

    const type = _.some(newBooking.joins, { active: true, type: 'schedules' }) ? 'schedules' : 'windows'

    if (type === 'windows') {
      const activeWindowIDs = []
      let activeServiceIDs = []

      _.forEach(newBooking.joins, join => {
        if (join.active) {
          _.forEach(join.windows, window => {
            _.forEach(window.services, service => {
              activeServiceIDs.push(service.id)
            })
            activeWindowIDs.push(window.id)
          })
        }
      })
      activeServiceIDs = _.uniq(activeServiceIDs)

      bookingPayload = {
        window_ids: activeWindowIDs,
        booking_type: 'windows',
        unit_id: newBooking.unit.id,
        price_company_id: newBooking.unit.company_id,
        user_id: newBooking.selectedUser.id,
        service_ids: activeServiceIDs,
        parallel: newBooking.parallel,
        special_master: newBooking.specialMaster,
        booking_source_id: bookingSources.length > 0 ? bookingSources[0].id : null,
      }
    } else {
      const schedules = []
      _.forEach(newBooking.joins, join => {
        if (join.active) {
          _.forEach(join.windows, window => {
            const serviceIDs = _.map(window.services, service => service.id)
            schedules.push({
              id: window.id,
              service_ids: serviceIDs,
              ranges: [window.begin_at, window.end_at],
            })
          })
        }
      })

      bookingPayload = {
        schedules,
        booking_type: 'schedules',
        unit_id: newBooking.unit.id,
        user_id: newBooking.selectedUser.id,
        parallel: newBooking.parallel,
        special_master: newBooking.specialMaster,
        booking_source_id: bookingSources.length > 0 ? bookingSources[0].id : null,
      }
    }

    return axios({
      method: 'POST',
      url: `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.all}`,
      data: bookingPayload,
      headers: {
        'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
      },
    })
      .then(response => {
        payload.bookingIndex++
        if (payload.bookingIndex < store.getters.newBookings.length) {
          store.dispatch('CREATE_BOOKING', payload.bookingIndex)
        } else {
          commit('setSusseeded', true)
          commit('setLastBookingID', response.data.data.id)
        }
      })
      .catch(error => {
        ServerValidationError.notify(error, 'customerValidation')
        commit('setLoad', false)

        let message = 'Ошибка сохранения!'
        if (error.response.status === 1401) {
          message = 'Окно уже используется!'
        }

        Vue.notify({
          group: 'hasBottomNavigation',
          title: '',
          type: 'error',
          text: message,
        })
      })
  },
  GET_ORDER_HISTORY_BY_BOOKING_ID({ commit, state, rootGetters }, bookingID) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.finances.orders}`,
      {
        params: {
          search: `booking_id:${bookingID}`,
          searchFields: `booking_id:=`,
          with: 'payments;items;images;items.item;items.employer',
        },
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const items = response.data.data.items
        let images = []
        let services = []
        let payments = []

        _.each(items, item => {
          if (item.images && !_.isEmpty(item.images)) {
            images = images.concat(item.images)
          }
          let totalPrice = 0
          let payedPrice = 0
          _.each(item.payments, payment => {
            payedPrice += Number(payment.amount)
          })
          _.each(item.items, entity => {
            if (entity.item_type === 'App\\Models\\Certificate') {
              if (entity.item) {
                entity.title = `Сертификат: ${entity.item.number}`
              } else {
                entity.title = ''
              }
            }
            if (entity.item_type === 'App\\Models\\Service' || entity.item_type === 'App\\Models\\Good') {
              if (entity.item) {
                entity.title = entity.item.title
              } else {
                entity.title = ''
              }
            }
            totalPrice += +entity.price * +entity.qty
            if (entity.employer) {
              entity.employer.full_name = full_name.by(entity.employer)
            } else {
              entity.employer = { full_name: '' }
            }
          })
          services = services.concat(item.items)
          payments = payments.concat(item.payments)
          item.totalPrice = totalPrice
          item.payedPrice = payedPrice
          item.diff = totalPrice - payedPrice
        })
        items.services = services
        items.payments = payments
        items.images = images
        commit('setBookingPaymentHistory', items)
      }
    })
  },
  GET_BOOKING_HISTORY({ state, commit, rootGetters }, bookingID) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.audits.all}`,
      {
        params: {
          search: `model_type:App\\Models\\Booking;model_id:${bookingID}`,
          searchFields: 'model_type:=;model_id:=',
          searchJoin: 'and',
          with: `user;users;employers;creators;bookings;units;companies;items;bookingStatuses;authors`,
        },
      },
      true,
    ).then(response => {
      const result = response.data.data.items.reverse()
      const resultArray = []
      const dictionary = Vue.config.localization.ru.bookingStatusHistory.dictionary
      let user = null

      for (let i = 0; i < result.length; i++) {
        const beforeArray = []
        const afterArray = []

        for (const key in result[i].changes_with_models) {
          if (key === 'failed_window_ids') continue
          let oldValue = result[i].changes_with_models[key][0]
          let newValue = result[i].changes_with_models[key][1]
          user = result[i].user

          if (key === 'status_id') {
            if (result[i].changes_with_models[key][0])
              oldValue =
                rootGetters.bookingStatuses.find(x => x.id === result[i].changes_with_models[key][0])?.name ?? ''
            if (result[i].changes_with_models[key][1])
              newValue =
                rootGetters.bookingStatuses.find(x => x.id === result[i].changes_with_models[key][1])?.name ?? ''
          }

          if (key === 'booking_source_id') {
            if (result[i].changes_with_models[key][0])
              oldValue = Vue.config.booking_source.find(x => x.id === result[i].changes_with_models[key][0])?.name ?? ''
            if (result[i].changes_with_models[key][1])
              newValue = Vue.config.booking_source.find(x => x.id === result[i].changes_with_models[key][1])?.name ?? ''
          }

          if (key === 'end_at' || key === 'begin_at') {
            if (result[i].changes_with_models[key][0])
              oldValue = moment(result[i].changes_with_models[key][0]).format('DD.MM.YYYY HH:mm')
            if (result[i].changes_with_models[key][1])
              newValue = moment(result[i].changes_with_models[key][1]).format('DD.MM.YYYY HH:mm')
          }

          if (key === 'unit') {
            if (result[i].changes_with_models[key][0]) oldValue = result[i].changes_with_models[key][0]?.name ?? ''
            if (result[i].changes_with_models[key][1]) newValue = result[i].changes_with_models[key][1]?.name ?? ''
          }

          if (key === 'special_master') {
            if (result[i].changes_with_models[key][0]) oldValue = 'Да'
            if (result[i].changes_with_models[key][1]) newValue = 'Да'
          }

          if (key === 'status') {
            if (result[i].changes_with_models[key][0]) oldValue = result[i].changes_with_models[key][0]?.name ?? ''
            if (result[i].changes_with_models[key][1]) newValue = result[i].changes_with_models[key][1]?.name ?? ''
          }

          if (key === 'user') {
            if (result[i].changes_with_models[key][0])
              oldValue = full_name.by(result[i].changes_with_models[key][0], undefined, true)
            if (result[i].changes_with_models[key][1])
              newValue = full_name.by(result[i].changes_with_models[key][1], undefined, true)
          }

          if (key === 'author') {
            if (result[i].changes_with_models[key][0])
              oldValue = full_name.by(result[i].changes_with_models[key][0], undefined, true)
            if (result[i].changes_with_models[key][1])
              newValue = full_name.by(result[i].changes_with_models[key][1], undefined, true)
          }

          if (key === 'company') {
            if (result[i].changes_with_models[key][0]) oldValue = result[i].changes_with_models[key][0]?.name ?? ''
            if (result[i].changes_with_models[key][1]) newValue = result[i].changes_with_models[key][1]?.name ?? ''
          }

          if (key === 'duration') {
            if (result[i].changes_with_models[key][0])
              oldValue = moment.duration(result[i].changes_with_models[key][0], 'seconds').format('h[ч] m[м]')
            if (result[i].changes_with_models[key][1])
              newValue = moment.duration(result[i].changes_with_models[key][1], 'seconds').format('h[ч] m[м]')
          }

          const translate = dictionary[key] ? dictionary[key] : key
          beforeArray.push(`${translate}: <strong> ${oldValue ? oldValue : '-'}</strong>`)
          afterArray.push(`${translate}: <strong> ${newValue ? newValue : '-'}</strong>`)
        }

        resultArray.push({
          date: result[i].created_at,
          user,
          before: beforeArray,
          after: afterArray,
        })
      }
      commit('setBookingHistory', resultArray)
    })
  },
}
